import { render, staticRenderFns } from "./Conjugue.vue?vue&type=template&id=83ce8cd2&"
import script from "./Conjugue.vue?vue&type=script&lang=js&"
export * from "./Conjugue.vue?vue&type=script&lang=js&"
import style0 from "./Conjugue.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports